import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import Swal from 'sweetalert2';
import { FilterDialogModalComponent } from '../shared-components/filter-dialog-modal/filter-dialog-modal.component';
import { LOGGED_IN_PROPERTY, LOGGED_IN_USER, SINGLE_PROPERTY, SUPER_ADMIN, USER_INFO } from '../util/constants';
import { NGaugeService } from './shared/ngauge.service';

@Injectable()
export class UserService {

  constructor(
    public httpClient: HttpClient,
    public dialog: MatDialog,
    public ngaugeService: NGaugeService) { }

  private logOutActivitySub = new BehaviorSubject<any>(null);
  logOutActivity$ = this.logOutActivitySub.asObservable();
  userUpdateSub = new BehaviorSubject<any>(null);
  userUpdated$ = this.userUpdateSub.asObservable();
  private userDashboardUpdateSub = new BehaviorSubject<any>(null);
  userDashboardUpdated$ = this.userDashboardUpdateSub.asObservable();

  userUpdateDone(value) {
    this.userUpdateSub.next(value);
  }

  userDashboardUpdateDone(value) {
    this.userDashboardUpdateSub.next(value);
  }

  getAccessToken() {
    const user = JSON.parse(sessionStorage.getItem(LOGGED_IN_USER));
    return user['token'];
  }

  getSID() {
    const user = JSON.parse(sessionStorage.getItem(LOGGED_IN_USER));
    return user['SID'];
  }

  getAccessInfo() {
    const user = JSON.parse(sessionStorage.getItem(LOGGED_IN_USER));
    return user;
  }

  getSessionStorage() {
    return JSON.parse(sessionStorage.getItem(USER_INFO));
  }

  getUserDetailsById() {
    const userInfo = this.getSessionStorage();
    return this.httpClient.get(this.ngaugeService.getMeldURL('GETADMINDATA') + userInfo['id']);
  }

  getLoggedInUserProperty() {
    const currentProperty = sessionStorage.getItem(LOGGED_IN_PROPERTY);
    return currentProperty;
  }

  getLoggedInUserId() {
    const userInfo = this.getSessionStorage();
    return userInfo['id'];
  }

  getLoggedInUserType() {
    const userInfo = this.getSessionStorage();
    return userInfo['userType'];
  }

  getLoggedInUserName() {
    const userInfo = this.getSessionStorage();
    return userInfo['userName'];
  }

  getLoggedInJobTitle() {
    const userInfo = this.getSessionStorage();
    return userInfo['jobTitle'];
  }

  getLoggedInLogo() {
    const userInfo = this.getSessionStorage();
    return userInfo['propertyLogo'];
  }

  getLoggedInGroup() {
    const userInfo = this.getSessionStorage();
    return userInfo['group'];
  }
  getLoggedInEmail() {
    const userInfo = this.getSessionStorage();
    return userInfo['email'];
  }

  getLoggedInUser() {
    const userInfo = this.getSessionStorage();
    return userInfo['loggedInUserName'];
  }

  getLoggedInPropertyType() {
    const userInfo = this.getSessionStorage();
    return userInfo['propertyType'];
  }

  getLoggedInUserGoals() {
    const userInfo = this.getSessionStorage();
    return userInfo['userGoals'];
  }

  getJobTitle() {
    const whereCondition = '"where":{"status":"Active"}';
    const whereSID = `"where":{"SID": "${ this.getSID()}"}`;
    const columnFilter = '"fields": ["name", "id","SID"]';
    const orderby = '"order":"name asc"';
    const filter = `{ ${columnFilter}, ${orderby}, ${whereCondition}, ${whereSID} }`;
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_USER_JOB_TITLE'), params);
  }

  getAllJobTitle() {
    const columnFilter = '"fields": ["name", "id", "status","SID"]';
    const orderby = '"order":"name asc"';
    const filter = `{ ${columnFilter}, ${orderby} }`;
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GET_USER_JOB_TITLE'), params);
  }

  getActiveusers() {
    return this.getUserConditionally('adminUsers');
  }

  getUserConditionally(userVariable) {
    if (this.ngaugeService[userVariable] !== null && this.ngaugeService[userVariable].length > 0) {
      let adminUsers = this.ngaugeService.removeArrayDuplicates(this.ngaugeService[userVariable], 'userName');
      adminUsers = adminUsers.filter(user => user['id'] !== 0);
      return Observable.of(adminUsers);
    } else {
      const property = this.getLoggedInUserProperty();
      const SID = JSON.parse(sessionStorage.getItem(LOGGED_IN_USER))["SID"];
      const whereFilter = userVariable === 'adminUsers' ?
        '"where": {"and": [{"status": "active"}, {"property": { "like": "%' + property + '%"}},' +
        '{ "or": [{ "usergroup": "sales" }, { "usergroup": "operations" }]}]} ' :
        '"where": {"property": { "like": "%' + property + '%"}}';
      const fieldArray = ['id', 'firstName', 'lastName', 'type', 'image',"SID", 'jobTitle', 'property',
        'username', 'email', 'usergroup', 'status'];
      if (userVariable === 'adminUsers') {
        fieldArray.push('status');
        fieldArray.push('mobileNumber');
      }
      const fields = '"fields" :' + JSON.stringify(fieldArray);
      const FILTER = '{' + whereFilter + ',' + fields + '}';
      const params = { params: this.ngaugeService.getHttpParams(FILTER) };
      return this.httpClient.get(this.ngaugeService.getMeldURL('GETADMINUSERS'), params).map((users: any) => {
        users.forEach(eachuser => {
          if (eachuser.SID==null){
            eachuser.SID=sessionStorage.getItem('sid')
          }
        });
        users = this.ngaugeService.appendFNameAndLName(users);
        users = this.ngaugeService.sortByContent(users, 'userName');
        users = this.ngaugeService.removeArrayDuplicates(users, 'userName');
        this.ngaugeService[userVariable] = JSON.parse(JSON.stringify(users));
        return this.ngaugeService[userVariable];
      });
    }
  }

  getAllUsers() {
    return this.getUserConditionally('reportAdminUsers');
  }

  getClusterUsers() {
    if (this.ngaugeService.clusterUsers !== null && this.ngaugeService.clusterUsers.length > 0) {
      let clusterUsers = this.ngaugeService.clusterUsers;
      clusterUsers = clusterUsers.filter(user => user['id'] !== 0);
      return Observable.of(clusterUsers);
    } else {
      const fields = '"fields" :["id", "firstName", "lastName","SID", "type", "image", "jobTitle", "property",' +
        '"username", "email", "usergroup"]';
      const whereCondition = '"where":{ "or": [{ "usergroup": "sales" }, { "usergroup": "operations" }]}';
      const FILTER = '{' + fields + ',' + whereCondition + '}';
      const params = { params: this.ngaugeService.getHttpParams(FILTER) };
      return this.httpClient.get(this.ngaugeService.getMeldURL('GETADMINUSERS'), params).map((users: any) => {
        users = this.ngaugeService.appendFNameAndLName(users);
        users = this.ngaugeService.sortByContent(users, 'userName');
        this.ngaugeService.clusterUsers = JSON.parse(JSON.stringify(users));
        return this.ngaugeService.clusterUsers;
      });
    }
  }

  getUsersWithoutProperty() {
    if (this.ngaugeService.usersWithoutProperty !== null && this.ngaugeService.usersWithoutProperty.length > 0) {
      return of(this.ngaugeService.usersWithoutProperty);
    } else {
      const whereFilter = '"where":{"and":[{"status": "active"}, { "or": [{ "usergroup": "sales" },' +
        '{ "usergroup": "operations" }]}]}';
      const fields = '"fields" :["id", "firstName","SID"]';
      const FILTER = '{' + whereFilter + ',' + fields + '}';
      const params = { params: this.ngaugeService.getHttpParams(FILTER) };
      return this.httpClient.get(this.ngaugeService.getMeldURL('GETADMINUSERS'), params);
    }
  }

  getUsers() {
    let whereCondition:any
    const userinfo=JSON.parse(sessionStorage.getItem('$$NGauge-UserInfo$$'))
    if(JSON.parse(sessionStorage.getItem('sid'))==3 && userinfo.userType=='SuperAdmin'){//we are showing for yedla management superadmin's we show all the users irrespective of property
      whereCondition = '"where":{"and":[{ "or": [{ "usergroup": "sales" },{ "usergroup": "operations" }]}]}';

    }
    else{
      whereCondition = '"where":{"and":[{"property": { "like": "%' + this.getLoggedInUserProperty() + '%"}},' +
      ' { "or": [{ "usergroup": "sales" },{ "usergroup": "operations" }]}]}';
    }
    const fields = '"fields" :["id", "firstName", "lastName","SID", "type", "email", "image", "jobTitle", "property", "username", "status"]';
    const order = '"order":"status asc"';
    const filter = '{' + whereCondition + ',' + fields + ',' + order + '}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GETADMINUSERS'), params);
  }

  highlightUserScreen() {
    const d = document.getElementById('Users');
    d.classList.add('active');
  }

  // Find User on whole Application without storing session storage
  findUserbyId(id: number) {
    const access_token = this.getAccessToken();
    const FIELDS = '"fields" :["id", "firstName", "lastName", "type"]';
    const filter = '{' + FIELDS + '}';
    const httpOptions = {
      params: { filter: filter },
      headers: new HttpHeaders({ 'Authorization': access_token })
    };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GETADMINDATA') + id, httpOptions).map(user => {
      user['userName'] = `${user['firstName']} ${user['lastName']}`;
      return user;
    });
  }

  getUserbyId(id: number) {
    const query = '{ "where": {"SID":' + this.getSID() + ',"id":' + id + '}';
    const httpOptions = {
      params: { filter: query }
    };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GETADMINDATA'), httpOptions);
  }
  getUserNamebyId(id: number) {
    const filter = '{"where": {"id":' + id + '},"fields":["id", "firstName", "lastName"]}';
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GETADMINDATA'), params);
  }

  createUser(user, propertyType) {
    const userDetails = JSON.parse(sessionStorage.getItem(USER_INFO));
    user.createdBy = userDetails['id'];
    user.updatedBy = userDetails['id'];
    if (user.property.length > 1) {
      user.ismultiproperty = true;
      user.checked = false;
      user.property = JSON.stringify(user.property);
    } else {
      user.checked = true;
      user.ismultiproperty = false;
      user.property = user.property[0];
    }
    if (propertyType) {
      return this.httpClient.post(this.ngaugeService.getMeldURL('ADDUSER'), { 'credentials': user });
    } else {
      return this.httpClient.post(this.ngaugeService.getMeldURL('YMC_CREATE_USER'), { 'credentials': user });
    }
  }

  updateUser(updateUser) {
    let sid= JSON.parse(sessionStorage.getItem('sid'))
    return this.httpClient.put(this.ngaugeService.getMeldURL('UPDATEUSER'), { 'userdetail': updateUser , 'SID' : sid });
  }

  getAdminUserInDashboardNew(userType) {
    let filter = '';
    const property = this.getLoggedInUserProperty();
    const fields = '"fields": ["id", "firstName", "lastName","SID", "type", "property","jobTitle", "prospectinggoal", "apptmentgoal",' +
      ' "grouproomgoal", "username"]';
    let whereCondition = '';
    if (userType !== SUPER_ADMIN) {
      const whereSID = `"where":{"SID": "${ this.getSID()}"}`;
      whereCondition = '"where": {"and" :[{"type": {"neq":"' + SUPER_ADMIN + '"}},  {"status": "active"},' +
        '{ "usergroup":"sales"}, {"property": { "like": "%' + property + '%"}}]} ';
      filter = `{${fields}, ${whereCondition}, ${whereSID}}`;
    } else {
      const isCluster = this.ngaugeService.getIsClusterProperty();
      if (!isCluster) {
        const whereSID = `"where":{"SID": "${ this.getSID()}"}`;
        whereCondition = '"where": {"and":[{"status": "active"}, {"usergroup":"sales"},' +
          '{"or": [{"property": { "like": "%' + property + '%"}}, {"type":"' + SUPER_ADMIN + '"}]}]}';
        filter = `{${whereCondition},${fields}, ${whereSID}}`;
      } else {
        whereCondition = '"where": {"and":[{"status": "active"}, {"usergroup":"sales"},{"property": { "like": "%' + property + '%"}}]}';
        filter = `{${whereCondition},${fields}}`;
      }
    }
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GETADMINUSERS'), params);
  }

  deleteUser(action, id, username, property) {
    if (action === 'Deactivate') {
      return this.httpClient.post(this.ngaugeService.getMeldURL('INACTIVE_USER'), { 'userid': id , 'SID': sessionStorage.getItem('sid') });
    } else {
      return this.httpClient.post(this.ngaugeService.getMeldURL('ACTIVE_USER'), { 'username': username, 'property': property, 'SID':sessionStorage.getItem('sid') });
    }
  }

  activateUser(userId) {
    const params = { id: userId, status: 'active' };
    return this.httpClient.put(this.ngaugeService.getMeldURL('GETADMINUSERS') + '/' + userId, params);
  }

  deleteContact(contactId) {
    return this.httpClient.delete(this.ngaugeService.getMeldURL('CONTACT') + '/' + contactId);
  }

  deleteAccount(accountId, SID) {
    return this.httpClient.post(this.ngaugeService.getMeldURL('DELETE_ACCOUNT'), { accountid: accountId, SID: SID });
  }

  checkForUserName(userName) {
    const fields = '"fields": ["id", "username","SID"]';
    const whereFilter = '"where":{"and":[{"username": "' + userName + '"},' +
      '{ "or": [{ "usergroup": "sales" },{ "usergroup": "operations" }]}]}';
    const filter = `{${whereFilter},${fields}}`;
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GETADMINUSERS'), params);
  }

  checkForMail(mail) {
    const fields = '"fields": ["id","SID", "email"]';
    const whereFilter = '"where":{"and":[{"email": "' + mail + '"},' +
      '{ "or": [{ "usergroup": "sales" },{ "usergroup": "operations" }]}]}';
    const filter = `{${whereFilter},${fields}}`;
    const params = { params: this.ngaugeService.getHttpParams(filter) };
    return this.httpClient.get(this.ngaugeService.getMeldURL('GETADMINUSERS'), params);
  }

  addJobTitle(values, userId) {
    const SID = this.getSID()
    const data = {
      createdBy: userId,
      createdOn: new Date(),
      name: values,
      status: 'Active',
      id: 0,
      SID: SID
    };
    return this.httpClient.post(this.ngaugeService.getMeldURL('GET_USER_JOB_TITLE'), data);
  }

  removeJobTitle(id) {
    return this.httpClient.delete(this.ngaugeService.getMeldURL('GET_USER_JOB_TITLE') + '/' + id);
  }

  migrateUser(oldsalesperson, salesperson, oldsalespersonname, salespersonname) {
    const migrateuserinfo = { oldsalesperson, salesperson, oldsalespersonname, salespersonname };
    return this.httpClient.post(this.ngaugeService.getMeldURL('MIGRATE_USER'), { migrateuserinfo });
  }

  uploadFile(e) {
    return new Promise(resolve => {
      const imageDetails = e.files[0];
      if (imageDetails.size > 30000 && !imageDetails.type.includes('jpg') && !imageDetails.type.includes('jpeg')) {
        const swalObject = {
          title: '<strong>Invalid Image Found</strong>',
          text: 'Please upload a profile picture, jpg or jpeg, with size less than 30KB.',
        };
        const areYouSure = this.ngaugeService.swalOKButton(swalObject);
        Swal(areYouSure);
      } else {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.readAsDataURL(imageDetails);
      }
    });
  }

  populateContactDetails(searchContact, contacts) {
    const filteredContact = contacts.filter(contact => contact['userName'] === searchContact)[0];
    if (filteredContact['phoneNumber'][0] !== undefined) {
      if (filteredContact['phoneNumber'][0]['phNumber'] === undefined) {
        filteredContact['phoneNumber'] = this.ngaugeService.isJSON(filteredContact['phoneNumber']);
      }
    }
    filteredContact['preferredContact'] = '';
    if (filteredContact['phoneNumber'].length > 0) {
      const preferredContact = filteredContact['phoneNumber'].filter(phone => phone['preferred'] === true);
      if (preferredContact.length > 0) {
        filteredContact['preferredContact'] =
          preferredContact.length > 0 ?
            preferredContact[0]['phNumber'] : filteredContact['phoneNumber'][0]['phNumber'];
      }
    }
    return filteredContact;
  }

  populateSigners(salesPersonName, userName, salesPersonTitle, designation) {
    return ['\n',
      {
        table: {
          widths: ['*', 20, '*', 20],
          body: [
            [
              { text: 'Hotel Representative', bold: true, border: [false, false, false, false] },
              { text: ' ', border: [false, false, false, false] },
              { text: 'Client Representative', bold: true, border: [false, false, false, false] },
              { text: ' ', border: [false, false, false, false] }
            ],
            [{ text: salesPersonName, border: [false, false, false, true] },
            { text: ' ', border: [false, false, false, false] },
            { text: userName, border: [false, false, false, true] },
            { text: ' ', border: [false, false, false, false] }],
            [
              { text: salesPersonTitle, border: [false, false, false, true] },
              { text: ' ', border: [false, false, false, false] },
              { text: designation, border: [false, false, false, true] },
              { text: ' ', border: [false, false, false, false] }
            ],
          ]
        },
      },
      {
        table: {
          widths: ['*', '*', 20, '*', '*', 20],
          body: [
            [
              { text: 'Date:', border: [false, false, false, true] },
              { text: '[date|req|signer2]', border: [false, false, false, true], color: 'white' },
              { text: ' ', border: [false, false, false, false] },
              { text: 'Date:', border: [false, false, false, true] },
              { text: '[date|req|signer1]', border: [false, false, false, true], color: 'white' },
              { text: ' ', border: [false, false, false, false] }],
            [
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] },
              { text: '', border: [false, false, false, false] }
            ],
            [
              { text: 'Signature:', border: [false, false, false, true] },
              { text: '`[sig|req|signer2   ]`', border: [false, false, false, true], color: 'white' },
              { text: '', border: [false, false, false, false] },
              { text: 'Signature:', border: [false, false, false, true] },
              { text: '[sig|req|signer1   ]', border: [false, false, false, true], color: 'white' },
              { text: '', border: [false, false, false, false] }],
          ]
        }
      }
    ];
  }

  populateFilter(formFields, description, salesPersons, modalTitle) {
    const isMultiProperty = this.ngaugeService.checkForMultiCluster();
    const touserIndex = formFields.findIndex(field => field.key === 'touser');
    formFields[touserIndex]['arrayData'] = salesPersons;
    if (isMultiProperty) {
      this.ngaugeService.getPropertyTypesList().subscribe(types => {
        const toPropertyIndex = formFields.findIndex(field => field.key === 'property');
        formFields[toPropertyIndex]['arrayData'] = types.map(type => type.name);
      });
    }
    return this.dialog.open(FilterDialogModalComponent, {
      width: formFields.length === 1 ? '415px' : '507px',
      height: 'auto',
      data: {
        accept: 'Generate Report', reject: 'Cancel',
        modalTitle, formFields,
        description: description
      }
    });
  }

  getProperties(accountType): Promise<any[]> {
    return new Promise(resolve => {
      if (accountType !== SINGLE_PROPERTY || !this.ngaugeService.getIsClusterProperty()) {
        this.ngaugeService.getPropertyTypesList().subscribe(types => {
          resolve(types);
        });
      } else {
        const property = [{ name: this.getLoggedInUserProperty() }];
        resolve(property);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts